export const SET_APP_NEWS = 'SET_APP_NEWS';
